import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../App';
import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Shield } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const NotaryPage = () => {
  const { API, accessToken } = useContext(AuthContext);
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axios.get(`${API}/notary/profiles`, { headers });
      setProfiles(response.data);
    } catch (error) {
      toast.error('Failed to load notary profiles');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="notary-page">
        <div>
          <h1 className="text-2xl sm:text-4xl font-bold text-gray-900">Notary Services</h1>
          <p className="text-gray-600 mt-2">Manage notary profiles and sessions</p>
        </div>

        <Card className="glass-effect border-none card-shadow">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Shield size={20} />
              Notary Profiles
            </CardTitle>
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <div className="flex justify-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
              </div>
            ) : profiles.length > 0 ? (
              <div className="space-y-4">
                {profiles.map((profile) => (
                  <div key={profile.id} className="p-4 bg-gray-50 rounded-lg" data-testid={`notary-${profile.id}`}>
                    <p className="font-semibold">Jurisdiction: {profile.jurisdiction}</p>
                    <p className="text-sm text-gray-500">Commission: {profile.commission_number}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-500 py-8">No notary profiles yet</p>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default NotaryPage;